// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3wKFc","label":"LabeledBox_label__6-GQi"};